import { getProspectSources } from '../../../services/admin-roster-uploads';
import type { ProspectSourcesResponse } from '../../../types/adminRosterUploads';
import { useAdminFetch, type AdminFetchState } from '../useAdminFetch';

export type ProspectSourcesState = AdminFetchState<ProspectSourcesResponse>;

const MESSAGES = {
  log: 'Failed to load prospect sources:',
  fallback: 'Could not load where this prospect came from.',
};

/**
 * A prospect's provenance (imports, manual entries, and the record's creation stamp). System admin only: the caller mounts this for a system admin and
 * nobody else, because the endpoint 403s everyone else and the request should never be made.
 *
 * The caller keys this per prospect, so an error never carries over to a different one.
 */
export const useProspectSources = (prospectId: string) =>
  useAdminFetch(prospectId, getProspectSources, MESSAGES);
